import React, { ImgHTMLAttributes, useEffect, useState } from "react";
import LocalstorageService from "../../Service/LocalstorageService";

type AuthenticatedReportImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  src: string;
};

const AuthenticatedReportImage: React.FC<AuthenticatedReportImageProps> = ({
  src,
  alt = "",
  ...props
}) => {
  const [objectUrl, setObjectUrl] = useState<string>("");
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!src || !src.includes("/api/ProjectTrain/DownloadCMReport")) {
      setObjectUrl("");
      setFailed(false);
      return;
    }

    let disposed = false;
    let nextObjectUrl = "";
    const token = LocalstorageService.getLocalAccessToken();

    setFailed(false);
    setObjectUrl("");

    fetch(src, {
      headers: token ? { Authorization: token } : undefined,
    })
      .then(async (response) => {
        const contentType = response.headers.get("content-type") || "";
        const blob = await response.blob();

        if (!response.ok) {
          throw new Error(`Report image request failed with status ${response.status}`);
        }

        if (contentType.includes("text")) {
          const text = await blob.text();
          if (text.includes("Image does not exist")) {
            throw new Error("Report image does not exist");
          }
        }

        nextObjectUrl = URL.createObjectURL(blob);
        if (!disposed) {
          setObjectUrl(nextObjectUrl);
        }
      })
      .catch((error) => {
        console.error("Unable to load report image", error);
        if (!disposed) {
          setFailed(true);
        }
      });

    return () => {
      disposed = true;
      if (nextObjectUrl) {
        URL.revokeObjectURL(nextObjectUrl);
      }
    };
  }, [src]);

  if (failed) {
    return null;
  }

  return <img src={objectUrl || src} alt={alt} {...props} />;
};

export default AuthenticatedReportImage;
